<template>
    <div class="product-assignments constrain flex">
        <div class="ff">
            <div class="flex product-search">
                <input type="text" placeholder="Search Assignments..." v-model="search" class="search" @input="filter" />
                <div class="ff"></div>
                <checkbox v-model="show_completed_assignments" :checked="show_completed_assignments" :label="product.license_type === 'teacher' ? 'Show Past' : 'Show Completed'" />
            </div>
            <div class="assignments" v-if="assignments.length">
                <div class="flex flex-align assignment" v-for="assignment of filtered" :key="assignment.assignment_id">
                    <div class="number">{{assignment.chapter_number}}</div>
                    <div class="ff">
                        <router-link v-if="assignment.assignment_enabled" class="title" :to="{name: 'assignment', params: {assignment: assignment.assignment_id}}">{{assignment.chapter_title}}</router-link>
                        <div v-else class="title disabled" v-tooltip.top-start="'Please open this assignment from your LMS.'">{{assignment.chapter_title}}</div>
                        <div class="assignment-course">{{assignment.course.name}}</div>
                    </div>
                    <div class="flex flex-column assignment-options">
                        <template v-if="product.license_type === 'teacher'">
                            <div class="assignment-submissions flex flex-align">
                                <span class="started" v-if="assignment.submissions_started">{{assignment.submissions_started}} Started</span>
                                <span class="submitted" v-if="assignment.submissions_complete">{{assignment.submissions_complete}} Submitted</span>
                                <span class="no-submissions" v-if="!assignment.submissions_started && !assignment.submissions_complete">No Submissions</span>
                            </div>
                            <div class="flex">
                                <!-- TODO There's an error in logic here where the user might have a teacher license but they're not a teacher of the course in Canvas, etc. -->
                                <div class="assignment-due text-right">
                                    Due {{assignment.assignment_due_date | pretty('date')}} at {{assignment.assignment_due_date | pretty('time')}}
                                </div>
                                <a class="assignment-edit pointer" @click="edit(assignment)">Edit</a>
                                <a class="assignment-delete pointer" @click="remove(assignment)">Delete</a>
                            </div>
                        </template>
                        <template v-else>
                            <div class="assignment-state text-right" :class="assignment.submission_state">
                                {{state(assignment)}}
                            </div>
                            <div class="assignment-due text-right" v-if="assignment.submission_state === 'submitted'">
                                {{assignment.submission_score}} Point{{assignment.submission_score === 1 ? '' : 's'}}
                            </div>
                            <div class="assignment-due text-right" v-else>
                                Due {{assignment.assignment_due_date | pretty('date')}} at {{assignment.assignment_due_date | pretty('time')}}
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div v-else class="nothing">
                You have not {{product.license_type === 'student' ? 'been' : ''}} assigned any exercises.
            </div>
        </div>
        <product-metadata :product="product" />
    </div>
</template>

<script>
    import Options from '@/components/modals/Options.vue';
    import Assign from '@/components/modals/Assign.vue';

    export default {
        name: 'ProductAssignments',
        data(){
            return {
                loading: true,
                search: '',
                show_completed_assignments: true,
                assignments: []
            };
        },
        methods: {
            edit(assignment){
                this.$modal.show(Assign, {assignment}, {width: 700, height: 'auto', classes: 'modal'});
            },
            filter(){

            },
            state(assignment){
                if(assignment.submission_state){
                    const states = {
                        started: 'Started',
                        submitted: 'Turned In'
                    };

                    return states[assignment.submission_state];
                }else{
                    return 'Not Started';
                }
            },
            remove(assignment){
                const _this = this;

                this.$modal.show(Options, {
                    options: [
                        {
                            color: 'red',
                            title: 'Delete Assignment',
                            fn(){
                                _this.$http.delete(`/products/${_this.product.product_id}/assignments/${assignment.assignment_id}`)
                                .then(response => {
                                    _this.$toasted.success('The assignment has been deleted.');
                                    _this.assignments.splice(_this.assignments.indexOf(assignment), 1);
                                })
                                .catch(error => _this.$toasted.error('There was an error loading the product contents.'));
                            }
                        }
                    ]
                },
                {
                    width: 260,
                    height: 'auto',
                    classes: 'modal'
                });
            }
        },
        computed: {
            product(){
                return this.$store.getters.product;
            },
            filtered(){
                return this.assignments.filter(assignment => {
                    if(!this.show_completed_assignments){
                        if(this.product.license_type === 'teacher'){
                            if(new Date(assignment.assignment_due_date) < new Date()){
                                return false;
                            }
                        }else{
                            if(assignment.submission_state === 'submitted'){
                                return false;
                            }
                        }
                    }

                    if(this.search){
                        return assignment.assignment_title.toLowerCase().includes(this.search.toLowerCase());
                    }

                    return true;
                });
            }
        },
        created(){
            if(this.product){
                this.$http.get(`/products/${this.product.product_id}/assignments`)
                .then(response => {
                    this.assignments = response.$data.sort((a, b) => {
                        const a_parts = a.chapter_semver.split('.').map(val => parseInt(val));
                        const b_parts = b.chapter_semver.split('.').map(val => parseInt(val));

                        let a_part = null;

                        while(a_part = a_parts.shift()){
                            let b_part = b_parts.shift();

                            if(b_part){
                                if(b_part === a_part){
                                    continue;
                                }

                                return a_part > b_part ? 1 : -1;
                            }else{
                                return 1;
                            }
                        }

                        return b_parts.length ? -1 : 1;
                    });
                })
                .catch(error => {
                    this.$toasted.error('There was an error loading your assignments.');
                    console.log(error)
                })
                .finally(() => this.loading = false);
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    @section-font-size: 24px;
    @number-width: 50px;

    .product-assignments
    {
        padding: 50px;
    }

    .product-search
    {
        padding-bottom: 25px;
    }

    .search
    {
        max-width: 400px;
    }

    .product
    {
        padding: 40px 50px;

        .toc
        {
            // padding-top: 50px;
        }
    }

    .assignment
    {
        padding: 4px 0;
        line-height: 24px;
        margin-bottom: 15px;

        .number
        {
            width: @number-width;
            font-size: 15px;
            color: var(--secondary-text-color);
            position: absolute;
            left: -1 * @number-width;
            top: 4px;
        }

        .title
        {
            cursor: pointer;
            font-size: 15px;
            color: var(--primary-text-color);

            &::after
            {
                content: "";
                position: absolute;
                border-bottom: 1px solid var(--secondary-text-color);
                top: 0;
                left: 0;
                bottom: -2px;
                pointer-events: none;
                width: 0;
                transition: width ease 0.2s;
            }

            &:hover, &:active
            {
                &::after
                {
                    width: 100%;
                }
            }

            &.disabled
            {
                color: @grey;

                &::after
                {
                    display: none;
                }
            }
        }

        .questions-icon, .simulations-icon
        {
            width: 24px;
            height: 24px;
            opacity: 0.2;

            &.active
            {
                opacity: 1;
            }
        }

        .questions-icon
        {
            background: url('~@/assets/icons/grey/questions.svg') 5px 7px no-repeat;
            background-size: 14px auto;
        }

        .simulations-icon
        {
            background: url('~@/assets/icons/grey/simulations.svg') 2px 7px no-repeat;
            background-size: 22px auto;
        }

        .text-button
        {
            margin-right: 10px;
            font-size: 15px;
            font-weight: 400;
            line-height: 24px;
            height: 24px;
        }
    }

    .assignment-course
    {
        font-size: 13px;
        color: var(--secondary-text-color);
        line-height: 16px;
        margin-top: 2px;
    }

    .assignment-state
    {
        font-size: 13px;
        color: var(--secondary-text-color);
        line-height: 18px;

        &.started
        {
            color: var(--primary-text-color);
        }

        &.submitted
        {
            color: @base;
        }
    }

    .assignment-delete, .assignment-edit
    {
        font-size: 12px;
        line-height: 16px;
        color: @red;
        transition: opacity ease 0.2s;
        margin-left: 10px;

        &:hover, &:active
        {
            opacity: 0.7;
        }

        &.assignment-edit
        {
            color: @base;
        }
    }

    .assignment-options
    {
        align-items: flex-end;
    }

    .assignment-due
    {
        font-size: 12px;
        color: var(--secondary-text-color);
        line-height: 16px;
    }

    .assignment-submissions
    {
        font-size: 13px;
        color: var(--primary-text-color);
        margin-bottom: 2px;
        margin-left: 10px;
    }
</style>